import script from "./Dados.vue?vue&type=script&setup=true&lang=js"
export * from "./Dados.vue?vue&type=script&setup=true&lang=js"

import "./Dados.vue?vue&type=style&index=0&id=731e65ed&lang=css"

const __exports__ = script;

export default __exports__